import React, { useContext, useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckoutSteps from "../CheckoutSteps/CheckoutSteps";
import { CartContext } from "../../contexts/CartContext";
import ApiService, { initialAuthState } from "../Services/ApiServices";
import PromoCode from "../Promocode/Promocode";
import toast, { Toaster } from "react-hot-toast";
import Navbar from "../New_Templates/Navbar";
import Footer from "../New_Templates/Footer";
import SelectAddressPage from "../Cart/Cart";
import { MdCelebration } from "react-icons/md";
import { FiLock } from "react-icons/fi";
import { createSlug } from "../../utils/slugify";
import "./OrderDetailsPage.css";

function OrderDetailsPage() {
  const location = useLocation();
  const { cartItems, setCartItems, removeFromCart, addToCart, fetchCartItems } =
    useContext(CartContext);
  const [promoDiscount, setPromoDiscount] = useState(0);
  const [selectedPromoDetails, setSelectedPromoDetails] = useState(null);

  const checkoutState =
    location.state || JSON.parse(sessionStorage.getItem("checkout_session"));

  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false);

  const { isBuyNow, orderItems } = checkoutState || {};
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [backendSummary, setBackendSummary] = useState(null);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryError, setSummaryError] = useState("");

  const subtotal = backendSummary?.subtotal || 0;
  const shippingCharge = backendSummary?.shippingCharge || 0;
  const isShippingFree = backendSummary?.isShippingFree || false;
  const shippingDiscountAmount = backendSummary?.shippingDiscountAmount || 0;
  const totalTax = backendSummary?.totalTax || 0;
  const cgst = backendSummary?.taxBreakup?.cgst || 0;
  const sgst = backendSummary?.taxBreakup?.sgst || 0;
  const igst = backendSummary?.taxBreakup?.igst || 0;
  const couponDiscount = backendSummary?.couponDiscount || 0;
  const displayedCouponDiscount = backendSummary?.appliedCoupon?.discount || 0;

  const itemsTotalDisplay = backendSummary?.itemsTotalDisplay || 0;
  const itemsTotalWithGST = backendSummary?.itemsTotalWithGST || 0;
  const totalAmount = backendSummary?.totalAmount || 0;
  const orderTotal = backendSummary?.orderTotal || 0;
  const taxBenefit = itemsTotalDisplay - itemsTotalWithGST || 0;

  const [deliveryAddress, setDeliveryAddress] = useState(null);
  const [billingAddress, setBillingAddress] = useState(null);
  const [isBillingSame, setIsBillingSame] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [addressLoading, setAddressLoading] = useState(true);
  const [user, setUser] = useState(null);

  const [showItems, setShowItems] = useState(false);
  // const isTestUser = user?.phoneNumber === process.env.REACT_APP_TEST_USER_NUMBER;

  const testNumbers = (process.env.REACT_APP_TEST_USER_NUMBERS || "")
    .split(",")
    .map(num => num.trim());

  const isTestUser = testNumbers.includes(user?.phoneNumber);

  useEffect(() => {
    const checkProfile = async () => {
      try {
        const res = await ApiService.post("client/getWebClientDetailsById", {
          companyCode: initialAuthState.companyCode,
          unitCode: initialAuthState.unitCode,
        });

        const client = res?.data?.client || res?.data;
        setUser(client)

        if (!client?.name?.trim() || !client?.email?.trim()) {
          navigate("/my-profile", { replace: true });
          toast.error("Please complete your profile setup first");
        }
      } catch (err) {
        console.error("Profile check failed", err);
        navigate("/my-profile", { replace: true });
      }
    };

    checkProfile();
  }, []);

  // const displayedItems = isBuyNow ? orderItems : cartItems;

  // const displayedItems = useMemo(() => {
  //   return isBuyNow ? orderItems || [] : orderItems || [];
  // }, [orderItems, isBuyNow]);

  const displayedItems = useMemo(() => {
    return isBuyNow ? orderItems || [] : orderItems || [];
  }, [orderItems, cartItems, isBuyNow]);

  const displayedItemsNormalized = useMemo(() => {
    return displayedItems.map((item) => {
      if (isBuyNow) {
        return {
          ...item,
          device: {
            name: item.name,
            model: item.model,
            id: item.deviceId,
            image: item.image,
            amount: item.amount,
            discount: item.discount,
            relayAmt: item.relayAmt,
            isRelay: item.isRelay,
            network2gAmt: item.network2gAmt,
            network4gAmt: item.network4gAmt,
            subscriptionMonthlyAmt: item.subscriptionMonthlyAmt,
            subscriptionYearlyAmt: item.subscriptionYearlyAmt,
            isNetwork: item.isNetwork,
            isSubscription: item.isSubscription,
          },
        };
      }
      return item;
    });
  }, [displayedItems, isBuyNow]);

  const toNumber = (val) => Number(val) || 0;

  const calculateBaseItemPrice = (item) => {
    if (!item || !item.device) return 0;

    const baseAmount = toNumber(item.device.amount);
    const discount = toNumber(item.device.discount);
    const network2gAmt = toNumber(item.device.network2gAmt);
    const network4gAmt = toNumber(item.device.network4gAmt);
    const subscriptionMonthlyAmt = toNumber(item.device.subscriptionMonthlyAmt);
    const subscriptionYearlyAmt = toNumber(item.device.subscriptionYearlyAmt);

    // Calculate base price with discount
    let price = baseAmount;
    if (discount > 0) {
      price -= (baseAmount * discount) / 100;
    }

    // Add network amount
    if (item.network === "2G") {
      price += network2gAmt;
    } else if (item.network === "4G") {
      price += network4gAmt;
    }

    // Add subscription amount
    if (item.subscription === "monthly") {
      price += subscriptionMonthlyAmt;
    } else if (item.subscription === "yearly") {
      price += subscriptionYearlyAmt;
    }

    return price;
  };

  const isRelaySelected = (item) => {
    if (!item || !item.device) return false;

    const basePrice = calculateBaseItemPrice(item);
    const quantity = toNumber(item.quantity);
    const totalAmount = toNumber(item.totalAmount);
    const baseTotal = basePrice * quantity;

    return totalAmount > baseTotal;
  };

  const calculateFinalItemPrice = (item) => {
    const basePrice = calculateBaseItemPrice(item);
    const relayAmt = toNumber(item.device.relayAmt);

    const relaySelected = isRelaySelected(item);

    if (relaySelected && item.device.isRelay && relayAmt > 0) {
      return basePrice + relayAmt;
    }

    return basePrice;
  };

  const fetchOrderSummary = async () => {
    if (!deliveryAddress?.id || !displayedItemsNormalized?.length) {
      setSummaryLoading(false);
      return;
    }

    setSummaryError("");

    try {
      const payload = {
        addressId: deliveryAddress.id,

        cartItems: displayedItemsNormalized.map((item) => ({
          deviceId: Number(item.device.id),
          quantity: Number(item.quantity) || 1,
          subscriptionType: item.subscription || null,
          networkType: item.network || null,
          isRelay: Boolean(item.isRelay),
        })),

        couponCode: selectedPromoDetails?.promoCode || null,
        couponId: selectedPromoDetails?.id || null,

        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
      };

      const res = await ApiService.post("order/summary", payload);


      if (res.status) {
        const summary = res.data.summary;

        setBackendSummary(summary);

        const coupon = summary.appliedCoupon;

        if (coupon?.id) {
          setSelectedPromoDetails((prev) => {
            if (prev?.id === coupon.id) return prev;

            return {
              id: coupon.id,
              promoCode: coupon.code,
            };
          });
        } else if (coupon?.message) {
          toast.error(coupon.message);
          setSelectedPromoDetails(null);
        }
      } else {
        setSummaryError("Failed to fetch summary");
      }
    } catch (err) {
      console.error("Error fetching order summary:", err);

      setSummaryError(err?.message || "Failed to fetch order summary");
    } finally {
      setSummaryLoading(false);
      setPageLoading(false);
    }
  };

  // const fetchOrderSummary = async () => {
  //   if (!deliveryAddress?.id) return;
  //   if (!displayedItemsNormalized?.length) return;
  //   if (displayedItemsNormalized.length === 0) return;

  //   // setSummaryLoading(true);
  //   setSummaryError('');

  //   try {

  //     const payload = {
  //       addressId: deliveryAddress.id,

  //       cartItems: displayedItemsNormalized.map(item => ({
  //         deviceId: Number(item.device.id),
  //         quantity: Number(item.quantity) || 1,
  //         subscriptionType: item.subscription || null,
  //         networkType: item.network || null,
  //         isRelay: Boolean(item.isRelay),
  //       })),

  //       couponCode: selectedPromoDetails?.promoCode || null,
  //       couponId: selectedPromoDetails?.id || null,

  //       companyCode: initialAuthState.companyCode,
  //       unitCode: initialAuthState.unitCode,
  //     };

  //     const res = await ApiService.post("order/summary", payload);


  //     if (res.status) {
  //       const summary = res.data.summary;

  //       setBackendSummary(summary);

  //       const coupon = summary.appliedCoupon;

  //       if (coupon?.id) {
  //         setSelectedPromoDetails(prev => {
  //           if (prev?.id === coupon.id) return prev; // ✅ prevent re-trigger
  //           return {
  //             id: coupon.id,
  //             promoCode: coupon.code,
  //           };
  //         });
  //       } else if (coupon?.message) {
  //         // FAILURE
  //         toast.error(coupon.message);
  //         setSelectedPromoDetails(null);
  //       }
  //     } else {
  //       console.error(res, "Error fetching orders");
  //     }

  //   } catch (err) {
  //     console.error('Error fetching order summary:', err);
  //     setSummaryError(err.message || 'Failed to fetch order summary');
  //   } finally {
  //     setSummaryLoading(false);
  //   }
  // };

  useEffect(() => {
    if (!deliveryAddress?.id || !displayedItemsNormalized.length) return;

    setSummaryLoading(true);

    const timer = setTimeout(() => {
      fetchOrderSummary().finally(() => {
        setPageLoading(false);
      });
    }, 400);

    return () => clearTimeout(timer);
  }, [
    deliveryAddress?.id,
    JSON.stringify(displayedItemsNormalized),
    selectedPromoDetails?.id,
  ]);

  // useEffect(() => {
  //   fetchOrderSummary();
  // }, [deliveryAddress, displayedItemsNormalized, promoDiscount]);

  useEffect(() => {
    fetchOrders();
  }, []);


  useEffect(() => {
    const saved = JSON.parse(sessionStorage.getItem("checkout_session"));

    if (saved?.createdAt) {
      const diff = Date.now() - saved.createdAt;

      if (diff > 1000 * 60 * 30) {
        // 30 mins
        sessionStorage.removeItem("checkout_session");
        toast.error("Checkout session expired");
        navigate("/cart");
      }
    }
  }, []);

  const fetchOrders = async () => {
    try {
      const payload = {
        companyCode: initialAuthState.companyCode,
        unitCode: initialAuthState.unitCode,
        // clientId: userId,
      };
      const response = await ApiService.post(
        "client/getWebClientDetailsById",
        payload,
      );
      if (response.status) {
        setOrders(response.data.orders);
      } else {
        console.error("Error fetching orders");
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  const total = displayedItems.reduce(
    (sum, item) => sum + toNumber(item.totalAmount),
    0,
  );

  const totalOrdersAmount = orders.reduce(
    (sum, item) => sum + toNumber(item.totalAmount),
    0,
  );

  // const finalAmount = Math.max(0, total - promoDiscount);
  const finalAmount = backendSummary?.totalAmount || 0;


  const createOrderPayload = (razorpayResponse) => {
    return {
      razorpay_order_id: razorpayResponse.razorpay_order_id,
      razorpay_payment_id: razorpayResponse.razorpay_payment_id,
      razorpay_signature: razorpayResponse.razorpay_signature,

      orderItems: displayedItemsNormalized.map((item) => ({
        deviceId: Number(item.device.id),
        quantity: Number(item.quantity) || 1,

        // optional fields
        subscriptionType: item.subscription || null,
        networkType: item.network || null,
        isRelay: Boolean(item.isRelay),

        // future fields (optional)
        imeiNumber: item.imeiNumber || null,
        simNumber: item.simNumber || null,
      })),
    };
  };

  const placeOrder = async () => {
    if (isLoading) return;

    if (!isPolicyAccepted) {
      toast.error("Please accept Terms & Conditions to proceed");
      return;
    }

    setIsLoading(true);

    if (!deliveryAddress || !billingAddress) {
      alert(
        "Please provide both delivery and billing addresses before payment.",
      );
      return;
    }

    // const payload = { totalAmount: finalAmount };
    const payload = {
      // clientId,       // REQUIRED
      deliveryAddressId: deliveryAddress.id, // REQUIRED
      billingAddressId: billingAddress.id, // optional if different from delivery
      companyCode: initialAuthState.companyCode,
      unitCode: initialAuthState.unitCode,

      policyAccepted: isPolicyAccepted,

      couponCode: selectedPromoDetails?.promoCode || null,
      couponId: selectedPromoDetails?.id || null,
      cartItems: displayedItemsNormalized.map((item) => ({
        cartId: item.id,
        deviceId: Number(item.device.id),
        quantity: Number(item.quantity) || 1,
        subscriptionType: item.subscription || null,
        networkType: item.network || null,
        isRelay: Boolean(item.isRelay),
      })),
    };
    try {
      const response = await ApiService.post(
        "/order/createOrderIntent",
        payload,
      );
      if (response.status) handlePaymentVerify(response.data);
      else throw new Error("Failed to place order");
    } catch (err) {
      console.error("Error placing order:", err);

      const message =
        err?.data?.message || "Unable to process your order. Please try again.";

      const code = err?.data?.code;

      if (code === "ITEM_REMOVED") {
        navigate("/cart");
        toast.error(message);
      } else if (code === "CART_LOCKED") {
        toast.error(message);
      } else {
        toast.error(message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentVerify = async (data) => {
    const ORDER_ID = data?.orderId; // Razorpay order ID from backend

    const options = {
      key: process.env.REACT_APP_KEY_ID,
      amount: data.amount,
      currency: "INR",
      name: "WAY4TRACK",
      description: "Test Mode",
      image: "/images/logo.png",
      order_id: ORDER_ID,
      handler: async (response) => {
        // Prepare payload for backend verification

        const finalPayload = createOrderPayload({
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
        });

        try {
          const verifyData = await ApiService.post(
            "/order/OrderVerify",
            finalPayload,
          );

          console.log(verifyData, "data from the payment vcverify data")
          if (verifyData.status) {
            // if (
            //   verifyData?.status === true &&
            //   verifyData?.paymentVerified === true
            // ) {
            toast.success("Payment successful");
            await fetchCartItems();
            // clearCartAfterPayment();
            sessionStorage.removeItem("checkout_session");
            // navigate("/order-placed");
            navigate("/order-placed", {
              state: {
                order: {
                  orderId: verifyData.orderId || response.razorpay_order_id,
                  paymentId: response.razorpay_payment_id,
                  paymentMethod: "ONLINE",

                  amount: {
                    itemsTotal: backendSummary?.itemsTotalDisplay,
                    shipping: backendSummary?.shippingCharge,
                    isShippingFree: backendSummary?.isShippingFree,
                    discount: promoDiscount,
                    couponDiscount: displayedCouponDiscount.toFixed(2),
                    coupon: selectedPromoDetails?.promoCode || null,
                    tax: backendSummary?.totalTax,
                    total: backendSummary?.orderTotal,
                  },

                  items: displayedItemsNormalized.map((item) => ({
                    name: item.device.name,
                    model: item.device.model,
                    image: item.device.image?.[0],
                    quantity: item.quantity,
                    deviceId: item.device.id,
                    price: calculateFinalItemPrice(item),
                    total: item.totalAmount,
                    network: item.network || null,
                    subscription: item.subscription || null,
                    isRelay: item.isRelay,
                  })),

                  address: {
                    delivery: deliveryAddress,
                    billing: billingAddress,
                  },

                  promo: selectedPromoDetails
                    ? {
                      code: selectedPromoDetails.promoCode,
                      discount: promoDiscount,
                    }
                    : null,

                  createdAt: new Date().toISOString(),
                },
              },
            });
          } else
            toast.error(verifyData.message || "Payment verification failed");
        } catch (error) {
          console.error("Payment verification error:", error);
          toast.error("Something went wrong after payment");
        }
      },
      theme: { color: "#5f63b8" },
      modal: {
        escape: true,
        backdropclose: false,
        ondismiss: async () => {
          try {
            await ApiService.post("/order/releaseCartLock", {
              cartIds: displayedItemsNormalized.map((i) => i.id),
            });

            toast("Payment cancelled");
          } catch (err) {
            console.error("Failed to release cart lock", err);
          }
        },
      },
    };

    if (!window.Razorpay) {
      toast.error("Payment gateway failed to load");
      return;
    }

    const rzp1 = new window.Razorpay(options);
    rzp1.open();
  };

  // const clearCartAfterPayment = () => {
  //   const clientCartItems = cartItems.filter(item => Number(item.client.id) === Number(clientId));
  //   clientCartItems.forEach(async item => {
  //     await ApiService.post("/cart/deleteCartDetails", { id: item.id });
  //   });
  //   setCartItems([]);
  //   localStorage.removeItem("guestCartItems");
  // };

  // const clearCartAfterPayment = async () => {
  //   try {
  //     // remove only this user's items from context
  //     const updatedCart = cartItems.filter(
  //       item => Number(item.client?.id) !== Number(clientId)
  //     );

  //     setCartItems(updatedCart);

  //     // remove guest cart if exists
  //     localStorage.removeItem("guestCartItems");

  //     // optional: fetch fresh cart from backend
  //     // await fetchCartItems();

  //   } catch (error) {
  //     console.error("Error clearing cart:", error);
  //   }
  // };

  // ✅ FREE SHIPPING RULES

  const FREE_SHIPPING_MIN_AMOUNT = 3000;
  const FREE_SHIPPING_MIN_ITEMS = 1;

  // total items count
  const totalItems = displayedItemsNormalized.reduce(
    (sum, item) => sum + (Number(item.quantity) || 0),
    0,
  );

  // remaining amount
  const remainingAmount =
    Math.round(
      Math.max(FREE_SHIPPING_MIN_AMOUNT - itemsTotalDisplay, 0) * 100,
    ) / 100;

  // remaining items
  const remainingItems = Math.max(FREE_SHIPPING_MIN_ITEMS - totalItems, 0);

  // final eligibility
  const isFreeShippingEligible =
    itemsTotalDisplay >= FREE_SHIPPING_MIN_AMOUNT &&
    totalItems >= FREE_SHIPPING_MIN_ITEMS;

  const progressPercent = Math.min(
    (totalAmount / FREE_SHIPPING_MIN_AMOUNT) * 100,
    100,
  );

  const handleWhatsAppOrder = async () => {
    if (isLoading) return;

    if (!isPolicyAccepted) {
      toast.error("Please accept Terms & Conditions to proceed");
      return;
    }

    if (!deliveryAddress || !billingAddress) {
      toast.error("Please select delivery & billing address");
      return;
    }

    try {
      setIsLoading(true);

      const customerRes = await ApiService.post(
        "client/getWebClientDetailsById",
        {
          companyCode: initialAuthState.companyCode,
          unitCode: initialAuthState.unitCode,
        },
      );

      const customer = customerRes?.data?.client || customerRes?.data;

      const customerName = customer?.name || "Customer";
      const customerPhone = customer?.phone || customer?.mobile || "";
      const customerEmail = customer?.email || "";

      const itemsMessage = displayedItemsNormalized
        .map((item, index) => {
          const relaySelected = isRelaySelected(item);

          return `
*${index + 1}. ${item.device.name}*
Model: ${item.device.model || "-"}
Quantity: ${item.quantity}
Price: ₹${Number(item.totalAmount).toFixed(2)}

${item.network ? `Network: ${item.network}` : ""}
${item.subscription ? `Subscription: ${item.subscription}` : ""}
${relaySelected ? "Relay: Included" : ""}
`;
        })
        .join("\n");

      const message = `
*New Order Request - WAY4TRACK*

👤 *Customer Details*
Name: ${customerName}
Phone: ${customerPhone}
Email: ${customerEmail}

📦 *Order Items*
${itemsMessage}

💰 *Order Summary*
Items Total: ₹${itemsTotalDisplay.toFixed(2)}
Shipping: ${shippingCharge === 0 ? "FREE" : `₹${shippingCharge.toFixed(2)}`}
Discount: ₹${displayedCouponDiscount.toFixed(2)}
Order Total: ₹${orderTotal.toFixed(2)}

📍 *Delivery Address*
${deliveryAddress?.address || ""}
${deliveryAddress?.city || ""}
${deliveryAddress?.state || ""}
${deliveryAddress?.pincode || ""}

${selectedPromoDetails?.promoCode
          ? `🎁 Promo Code: ${selectedPromoDetails?.promoCode}`
          : ""
        }

Please confirm this order.
`;

      // YOUR WHATSAPP NUMBER
      const whatsappNumber = "919876543210";

      const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
        message,
      )}`;

      window.open(whatsappURL, "_blank");
    } catch (error) {
      console.error("WhatsApp order error:", error);

      toast.error("Unable to create WhatsApp order");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="order-details-container">
      {pageLoading && (
        <div className="summary-loading-overlay">
          <div className="summary-spinner"></div>
          <p>Loading...</p>
        </div>
      )}

      {/* <Navbar /> */}
      <CheckoutSteps currentStep={3} />

      <div className="order-header-confirmation">
        <h1 className="title">Order Confirmation</h1>
        <p className="order-subtitle">
          Review your order details before proceeding to payment
        </p>
      </div>

      <div className="order-details-grid">
        {/* Left: Cart Product Listing */}
        <div className="order-left">
          <SelectAddressPage
            deliveryAddress={deliveryAddress}
            setDeliveryAddress={setDeliveryAddress}
            billingAddress={billingAddress}
            setBillingAddress={setBillingAddress}
            isBillingSame={isBillingSame}
            setIsBillingSame={setIsBillingSame}
          />
          <div className="order-left-header">
            <h2 onClick={() => setShowItems(!showItems)} className="toggle">
              Order Items({displayedItemsNormalized.length}){" "}
              {showItems ? "▲" : "▼"}
            </h2>
            {/* <h2>{cartItems.length} items {showItems ? "▲" : "▼"}</h2> */}
            <span className="items-count">
              {displayedItemsNormalized.length} items
            </span>
          </div>

          {/* {displayedItemsNormalized.length > 0 ? (
            <div className="items-list">
              {displayedItemsNormalized.map((item) => {
                const relaySelected = isRelaySelected(item);
                const itemPrice = calculateFinalItemPrice(item);
                const totalPrice = toNumber(item.totalAmount);

                return (
                  <div key={item.id} className="cart-item">
                    <div className="item-image-container">
                      <img
                        src={item.device.image?.[0] || "/images/default.jpg"}
                        alt={item.device.name}
                        className="cart-image"
                      />
                    </div>
                    <div className="cart-item-text">
                      <div className="cart-item-header">
                        <span className="cart-header">{item.device.name}</span>
                        <span className="item-model">{item.device.model}</span>
                      </div>

                      <div className="cart-item-details">
                        {item.device.isRelay && item.device.relayAmt > 0 && (
                          <div className="detail-row">
                            <span className="detail-label">Accessories:</span>
                            <span className="detail-value">
                              {relaySelected ? "With Relay" : "Without Relay"}
                            </span>
                          </div>
                        )}

                        {item.device.isNetwork &&
                          (item.device.network2gAmt > 0 || item.device.network4gAmt > 0) && (
                            <div className="detail-row">
                              <span className="detail-label">Network:</span>
                              <span className="detail-value">{item.network || "Not selected"}</span>
                            </div>
                          )}

                        {item.device.isSubscription &&
                          (item.device.subscriptionMonthlyAmt > 0 || item.device.subscriptionYearlyAmt > 0) && (
                            <div className="detail-row">
                              <span className="detail-label">Subscription:</span>
                              <span className="detail-value">
                                {item.subscription ? `${item.subscription} subscription` : "Not selected"}
                              </span>
                            </div>
                          )}

                        {item?.state && item?.city && (
                          <>
                            <div className="detail-row">
                              <span className="detail-label">Location:</span>
                              <span className="detail-value">{item.city}, {item.state}</span>
                            </div>
                          </>
                        )}

                        <div className="detail-row">
                          <span className="detail-label">Base Unit Price:</span>
                          <span className="detail-value">₹{itemPrice.toFixed(2)}</span>
                        </div>

                        <div className="detail-row">
                          <span className="detail-label">Quantity:</span>
                          <span className="detail-value">{item.quantity}</span>
                        </div>
                      </div>

                      <div className="item-total">
                        <span className="cart-price">₹{totalPrice.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="empty-cart">
              <div className="empty-icon">🛒</div>
              <p>No items in cart</p>
            </div>
          )} */}

          {showItems &&
            (displayedItemsNormalized.length > 0 ? (
              <div className="items-list">
                {displayedItemsNormalized.map((item) => {
                  const relaySelected = isRelaySelected(item);
                  const itemPrice = calculateFinalItemPrice(item);
                  const totalPrice = toNumber(item.totalAmount);

                  return (
                    <div key={item.id} className="order-details-cart-item">
                      {/* Product Image */}
                      <div className="order-details-item-image-container">
                        <img
                          src={
                            item.device.image?.[0] ||
                            "https://storage.googleapis.com/way4track-application/device_media/1763618936164-image_1763618896161_328.png"
                          }
                          alt={item.device.name}
                          className="cart-image"
                        />
                      </div>

                      {/* Product Info */}
                      <div className="cart-item-text">
                        <div className="cart-item-header">
                          <div>
                            <h3
                              onClick={() => {
                                const slug = createSlug(item.device.name || item.device.webProductName);
                                navigate(`/products/${slug}`)
                              }}
                              className="cart-header">{item.device.name}</h3>
                            {/* <span className="item-model">{item.device.model}</span> */}
                          </div>

                          <h1 className="item-total">
                            ₹{totalPrice.toFixed(2)}
                          </h1>
                        </div>

                        {/* Configuration Badges */}
                        <div className="cart-config-badges">
                          {item.device.isRelay && item.device.relayAmt > 0 && (
                            <span className="config-badge">
                              ⚡ {relaySelected ? "Relay Included" : "No Relay"}
                            </span>
                          )}

                          {item.device.isNetwork &&
                            (item.device.network2gAmt > 0 ||
                              item.device.network4gAmt > 0) && (
                              <span className="config-badge">
                                📶 {item.network || "Network not selected"}
                              </span>
                            )}

                          {item.device.isSubscription &&
                            (item.device.subscriptionMonthlyAmt > 0 ||
                              item.device.subscriptionYearlyAmt > 0) && (
                              <span className="config-badge">
                                🔄 {item.subscription || "No Subscription"}
                              </span>
                            )}

                          {item?.state && item?.city && (
                            <span className="config-badge location-badge">
                              📍 {item.city}, {item.state}
                            </span>
                          )}
                        </div>

                        {/* Price Details */}
                        <div className="price-info">
                          <span>Unit Price: ₹{item.unitPrice}</span>
                          <span>Qty: {item.quantity}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="empty-cart">
                <div className="empty-icon">🛒</div>
                <p>No items in cart</p>
              </div>
            ))}

          {/* {displayedItemsNormalized.length > 0 ? (
            <div className="checkout-items-list">
              {displayedItemsNormalized.map((item) => {
                const relaySelected = isRelaySelected(item);
                const itemPrice = calculateFinalItemPrice(item);
                const totalPrice = toNumber(item.totalAmount);

                return (
                  <div key={item.id} className="checkout-item-card">

                    <div className="checkout-item-image">
                      <img
                        src={item.device.image?.[0] || "/images/default.jpg"}
                        alt={item.device.name}
                      />
                    </div>

                    <div className="checkout-item-info">

                      <div className="checkout-item-title">
                        <h4>{item.device.name}</h4>
                        <span className="model">{item.device.model}</span>
                      </div>

                      <div className="checkout-config">

                        {item.device.isRelay && item.device.relayAmt > 0 && (
                          <div className="config-row">
                            <span>Accessories</span>
                            <b>{relaySelected ? "With Relay" : "Without Relay"}</b>
                          </div>
                        )}

                        {item.device.isNetwork &&
                          (item.device.network2gAmt > 0 ||
                            item.device.network4gAmt > 0) && (
                            <div className="config-row">
                              <span>Network</span>
                              <b>{item.network || "Not selected"}</b>
                            </div>
                          )}

                        {item.device.isSubscription &&
                          (item.device.subscriptionMonthlyAmt > 0 ||
                            item.device.subscriptionYearlyAmt > 0) && (
                            <div className="config-row">
                              <span>Subscription</span>
                              <b>
                                {item.subscription
                                  ? `${item.subscription}`
                                  : "Not selected"}
                              </b>
                            </div>
                          )}

                        {item?.state && item?.city && (
                          <div className="config-row">
                            <span>Delivery Location</span>
                            <b>{item.city}, {item.state}</b>
                          </div>
                        )}

                      </div>

                      <div className="checkout-qty">
                        Qty : <b>{item.quantity}</b>
                      </div>

                    </div>

                    <div className="checkout-price">

                      <div className="unit-price">
                        <span>Unit Price</span>
                        <b>₹{itemPrice.toFixed(2)}</b>
                      </div>

                      <div className="total-price">
                        ₹{totalPrice.toFixed(2)}
                      </div>

                    </div>

                  </div>
                );
              })}
            </div>
          ) : (
            <div className="empty-cart">
              <div className="empty-icon">🛒</div>
              <p>No items in cart</p>
            </div>
          )} */}
        </div>

        {/* <div className="addresses-section">
          <AddressCard
            address={deliveryAddress}
            title="Shipping Address"
            type="Delivery"
          />

          <AddressCard
            address={billingAddress}
            title="Billing Address"
            type="Billing"
          />
          <CartPage />
        </div> */}

        {/* Right: Address + Summary */}
        <div className="order-right">
          <div className="promo-section">
            <PromoCode
              totalAmount={total}
              onApply={(discount, promoDetails) => {
                const num = Number(discount) || 0;
                setPromoDiscount(num);
                setSelectedPromoDetails(promoDetails);
              }}
              onRemove={() => {
                setPromoDiscount(0);
                setSelectedPromoDetails(null);
              }}
              cartItems={cartItems}
              addressId={deliveryAddress?.id}
            />
          </div>

          <div className="cart-shipping-card">
            <div className="cart-shipping-header">
              <span className="shipping-title">Shipping Benefits</span>

              {isFreeShippingEligible && (
                <span className="shipping-badge">FREE SHIPPING UNLOCKED</span>
              )}
            </div>

            {/* Progress Bar */}
            <div className="shipping-progress-wrapper">
              <div
                className="shipping-progress-bar"
                style={{ width: `${progressPercent}%` }}
              />
            </div>

            {/* Dynamic Message */}
            <div className="shipping-message">
              {isFreeShippingEligible ? (
                <p className="success-msg">
                  You are eligible for <strong>Free Shipping</strong>
                </p>
              ) : (
                <p className="info-msg">
                  {remainingAmount > 0 && (
                    <>
                      Add <strong>₹{remainingAmount}</strong>
                    </>
                  )}
                  {remainingAmount > 0 && remainingItems > 0 && " and "}
                  {remainingItems > 0 && (
                    <>
                      <strong>
                        {remainingItems} more item
                        {remainingItems > 1 ? "s" : ""}
                      </strong>
                    </>
                  )}{" "}
                  to unlock <strong>Free Shipping</strong>
                </p>
              )}
            </div>
          </div>

          <div className="order-section order-section-summary summary-wrapper">
            {summaryLoading && (
              <div className="summary-loading-overlay">
                <div className="summary-spinner"></div>
                <p>Calculating summary...</p>
              </div>
            )}
            <h2>Order Summary</h2>

            <div className="summary-content">
              <div className="summary-row">
                <span className="summary-label">Items Total:</span>
                <span className="summary-value">
                  ₹{itemsTotalDisplay.toFixed(2)}
                </span>
              </div>

              {/* {cgst > 0 && (
                <div className="summary-row">
                  <span className="summary-label">CGST</span>
                  <span className="summary-value">₹{cgst.toFixed(2)}</span>
                </div>
              )}

              {sgst > 0 && (
                <div className="summary-row">
                  <span className="summary-label">SGST</span>
                  <span className="summary-value">₹{sgst.toFixed(2)}</span>
                </div>
              )}

              {igst > 0 && (
                <div className="summary-row">
                  <span className="summary-label">IGST</span>
                  <span className="summary-value">₹{igst.toFixed(2)}</span>
                </div>
              )} */}

              {/* {cgst > 0 && (
                <div className="summary-row">
                  <span className="summary-label">Taxes:</span>
                  <span className="summary-value">₹{totalTax.toFixed(2)}</span>
                </div>
              )} */}

              <div className="summary-row">
                <span className="summary-label">Delivery Charges:</span>
                <span className="summary-value">
                  {shippingCharge === 0
                    ? "FREE"
                    : `₹${shippingCharge.toFixed(2)}`}
                </span>
              </div>

              <div className="summary-divider"></div>

              <div className="summary-row">
                <span className="summary-label">Total Amount:</span>
                <span className="summary-value">₹{totalAmount.toFixed(2)}</span>
              </div>

              {isShippingFree && (
                <div className="summary-row">
                  <span className="summary-label-free">Free Delivery:</span>
                  <span className="summary-value-free">
                    -₹{shippingDiscountAmount.toFixed(2)}
                  </span>
                </div>
              )}

              {couponDiscount > 0 && (
                <div className="summary-row">
                  <span className="summary-label-free">Coupon Discount:</span>
                  <span className="summary-value-free">
                    -₹{displayedCouponDiscount.toFixed(2)}
                  </span>
                </div>
              )}

              {/* {couponDiscount > 0 && (
                <div className="summary-row">
                  <span className="summary-label-free">Tax Benefit:</span>
                  <span className="summary-value-free">-₹{taxBenefit.toFixed(2)}</span>
                </div>
              )} */}

              <div className="summary-row total">
                <span className="summary-label">Order Total</span>
                <span className="summary-value final-amount">
                  ₹{orderTotal.toFixed(2)}
                </span>
              </div>

              {couponDiscount > 0 && (
                // <div className="summary-row discount">
                //   <span className="summary-label">You save:</span>
                //   <MdCelebration />
                //   <span className="summary-value">₹{(totalAmount - orderTotal).toFixed(2)}</span>
                // </div>
                <div className="summary-row discount-highlight">
                  <div className="save-left">
                    {/* <MdCelebration className="celebration-icon" /> */}
                    <span className="save-text">You Saved</span>
                  </div>

                  <div className="save-right">
                    <span className="save-amount">
                      ₹{(totalAmount - orderTotal).toFixed(2)}
                    </span>
                    <span className="save-tag">🎉</span>
                  </div>
                </div>
              )}
            </div>

            {backendSummary?.appliedCoupon?.id && (
              <div className="promo-applied-message">
                <span className="promo-success">✓</span>
                Promo code <strong>
                  {selectedPromoDetails?.promoCode}
                </strong>{" "}
                applied successfully!
              </div>
            )}

            {/* <div className="place-order-section">

              <p className="order-final-note">
                By placing this order, you agree to ourhipping, cancellation & replacements{" "}
                <span onClick={() => navigate("/policies")} className="policy-link">
                  policies
                </span>.
              </p>
            </div> */}

            <div className="checkout-policy-block">
              <p className="checkout-policy-title">
                ⚠ Review Before You Place Your Order
              </p>

              <ul className="checkout-policy-list">
                <li>
                  By placing this order, you agree to our{" "}
                  <span
                    onClick={() => navigate("/termsandconditions")}
                    className="policy-link"
                  >
                    Terms & Conditions and related policies
                  </span>
                  .
                </li>

                <li>
                  Orders are typically confirmed within minutes after payment
                  verification. Cancellation is allowed only before confirmation
                  by Way4Track.
                </li>

                <li>
                  Payment processing charges may be deducted if cancellation is
                  requested before confirmation.
                </li>
              </ul>

              {/* ✅ MANDATORY CHECKBOX */}
              <label className="checkout-agree">
                <input
                  type="checkbox"
                  checked={isPolicyAccepted}
                  onChange={(e) => setIsPolicyAccepted(e.target.checked)}
                />
                <span>
                  I have read and agree to the Terms & Conditions and policies
                </span>
              </label>
            </div>

            <div className="order-details-place-order-btn-container">
              <button
                // disabled
                className="place-order-btn"
                onClick={placeOrder}
                disabled={
                  !isTestUser ||
                  isLoading ||
                  summaryLoading ||
                  !deliveryAddress ||
                  !billingAddress ||
                  !backendSummary ||
                  !isPolicyAccepted
                }
              >
                {isLoading ? (
                  <>
                    <div className="loading-spinner"></div>
                    Processing...
                  </>
                ) : (
                  <>
                    {/* Proceed to Payment - ₹{finalAmount.toFixed(2)} */}
                    Place Order(coming soon)
                  </>
                )}
              </button>
              <button
                disabled={
                  isLoading ||
                  summaryLoading ||
                  !deliveryAddress ||
                  !billingAddress ||
                  !backendSummary ||
                  !isPolicyAccepted
                }
                className="order-details-page-whatspporder-checkout-btn"
                // onClick={() => navigate("/delivery-address")}

                onClick={handleWhatsAppOrder}
              >
                Order Via WhatsApp
              </button>
            </div>

            <p className="security-note">
              <FiLock className="lock-icon" />
              Your payment information is secure and encrypted
            </p>
          </div>
        </div>
      </div>

      {/* <Footer /> */}
    </div>
  );
}

export default OrderDetailsPage;
